export * from './lib/shared-ui-promo-banner'
